import eventone from '../Images/eventone.jpeg'
import eventtwo from '../Images/eventtwo.jpeg'
import eventthree from '../Images/eventthree.jpeg'
import aboutone from '../Images/aboutone.jpg'
import abouttwo from '../Images/abouttwo.jpg'
import one from '../Images/onea.jpeg'
import two from '../Images/twoa.jpeg'
import three from '../Images/threea.jpeg'
import four from '../Images/foura.jpeg'
import five from '../Images/fivea.jpeg'
import six from '../Images/sixa.jpeg'
import seven from '../Images/sevena.jpeg'
import eight from '../Images/eighta.jpeg'
import nine from '../Images/ninea.jpeg'
import ten from '../Images/tena.jpg'
import eleven from '../Images/elevena.jpg'
import twelve from '../Images/twelvea.jpg'
import thirteen from '../Images/thirteena.jpg'
import fourteen from '../Images/fourteena.jpg'
import fifteen from '../Images/fifteena.jpg'
import sixteen from '../Images/sixteena.jpg'
import seventeen from '../Images/seventeena.jpeg'
import eightteen from '../Images/eighteena.jpg'
import nineteen from '../Images/ninteena.jpg'
import twenty from '../Images/twentya.jpg'
import twentyone from '../Images/twentyonea.jpg'
import twentytwo from '../Images/twentytwoa.jpg'
import twentythree from '../Images/twentythreea.jpg'
import twentyfour from '../Images/twentyfoura.jpg'
import twentyfive from '../Images/twentyfivea.jpg'
import eone from '../Images/1.jpg'
import etwo from '../Images/2.jpg'
import ethree from '../Images/3.jpg'
import efour from '../Images/4.jpg'
import efive from '../Images/5.jpg'
import esix from '../Images/6.jpg'
import eseven from '../Images/7.jpg'
import eeight from '../Images/8.jpg'
import enine from '../Images/9.jpg'
import eten from '../Images/10.jpg'
import eeleven from '../Images/11.jpg'
import etwelve from '../Images/12.jpg'
const Imagegallery=[
    {
        img:aboutone,
        category:'room'
    },
    {
        img:abouttwo,
        category:'room'
    },
    {
        img:one,
        category:'room'
    },
    {
        img:two,
        category:'room'
    },
    {
        img:three,
        category:'room'
    },
    {
        img:four,
        category:'room'
    },
    {
        img:five,
        category:'room'
    },
    {
        img:six,
        category:'room'
    },
    {
        img:seven,
        category:'room'
    },
    {
        img:eight,
        category:'room'
    },
    {
        img:nine,
        category:'room'
    },
    {
        img:eventone,
        category:'event'
    },
    {
        img:eventtwo,
        category:'event'
    },
    
    {
        img:eventthree,
        category:'event'
    }
    ,
    {
        img:ten,
        category:'event'
    },
    {
        img:eleven,
        category:'event'
    },
    
    {
        img:twelve,
        category:'event'
    },
    {
        img:thirteen,
        category:'event'
    },
    {
        img:fourteen,
        category:'event'
    },
    
    {
        img:fifteen,
        category:'event'
    },
    {
        img:sixteen,
        category:'event'
    },
    {
        img:seventeen,
        category:'event'
    },
    
    {
        img:eightteen,
        category:'event'
    },
    {
        img:nineteen,
        category:'event'
    },
    {
        img:twenty,
        category:'event'
    },
    
    {
        img:twentyone,
        category:'event'
    },
    {
        img:twentytwo,
        category:'event'
    },
    {
        img:twentythree,
        category:'event'
    },
     {
        img:eone,
        category:'event'
    },
         {
        img:etwo,
        category:'event'
    },
{
        img:ethree,
        category:'event'
    },
         {
        img:efour,
        category:'event'
    },
         {
        img:efive,
        category:'event'
    },
         {
        img:esix,
        category:'event'
    },
         {
        img:eseven,
        category:'event'
    },
         {
        img:eeight,
        category:'event'
    },
         {
        img:enine,
        category:'event'
    },
         {
        img:eten,
        category:'event'
    },
         {
        img:eeleven,
        category:'event'
    },
         {
        img:etwelve,
        category:'event'
    },
       
    {
        img:twentyfour,
        // category:'event'
    },
    {
        img:twentyfive,
        // category:'event'
    },
    
    
]
export default Imagegallery